<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BasePageTitleHeader',
  mixins: [baseMixin],
  props: {
    subtitleOnTop: {
      type: Boolean,
    },
  },
}
</script>

<template>
  <h2
    :class="[
      !isMobileViewPort
        ? 'text-h5 d-inline-block font-weight-medium'
        : 'text-subtitle-1 font-weight-medium',
      subtitleOnTop ? 'mt-0 mb-8' : 'mb-0',
    ]"
  >
    <slot></slot>
  </h2>
</template>
